import { parse } from "./parser.js";
import { evaluate } from "./evaluator.js";
/**
 * Cache of parsed ASTs, keyed by expression string.
 * Parsing happens once; evaluation reuses the compiled AST.
 */
const astCache = new Map();
/**
 * Parse and evaluate a formula expression against a context.
 * Parsed ASTs are cached for performance.
 */
export function evaluateExpression(expression, context) {
    let ast = astCache.get(expression);
    if (!ast) {
        ast = parse(expression);
        astCache.set(expression, ast);
    }
    return evaluate(ast, context);
}
/**
 * Clear the AST cache (for testing or rule bundle reload).
 */
export function clearExpressionCache() {
    astCache.clear();
}
//# sourceMappingURL=expression.js.map